export default "__VITE_ASSET__CLISFp9r__"